angular.module('invoice')
    .controller('InvoiceAdditionalInfoController', function ($rootScope, $uibModalInstance, data, Invoice, InvoiceConst, toastr) {
        this.loading = true
        this.invoice = data
        this.form = {date: moment().format('YYYY-MM-DD'), content: ''}

        this.$onInit = () => {
            Invoice.additionalInfo({id: data.id}).$promise.then(info => {
                this.form = {
                    date: info.date || this.form.date,
                    content: info.content || ''
                }
                this.audit = info
            }).catch(() => this.loadFailed = true).finally(() => this.loading = false)
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.save = () => {
            return Invoice.saveAdditionalInfo({id: data.id}, this.form).$promise.then(info => {
                data.additionalInfo = info
                toastr.success('Zapisano informację dodatkową')
                $rootScope.$broadcast(InvoiceConst.eventUpdate)
                $uibModalInstance.close(info)
            })
        }
    })
